import {
    type TextStyle,
    type ViewStyle,
    StyleSheet,
    type Role
} from "react-native";
import type {
    TableCellRoleConstantType,
    TableCellDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import type {
    TableAlign
} from "../../type";
import {
    getTableStickyZIndexes
} from "../../stylesheet";
import {
    withAlpha
} from "../../../../utils/color";
import {
    webStyle
} from "../../../../utils";

export const TABLE_CELL_ALIGNMENTS: Record<TableAlign, ViewStyle["alignItems"]> = {
    start: "flex-start",
    center: "center",
    end: "flex-end"
};

export const getTableCellRole = ({
    scope,
    kind
}: TableCellRoleConstantType): Role => {
    if(scope === "row") {
        return "rowheader";
    }

    return kind === "head" ? "columnheader" : "cell";
};

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        flexDirection: "column"
    },
    shrink: {
        flexShrink: 0,
        flexGrow: 0
    },
    fill: {
        flexShrink: 1,
        flexBasis: 0
    },
    text: {
        flexShrink: 1
    }
});

export const useStyles = ({
    isEdgeShadowVisible,
    directionSign,
    stickyOffset,
    shadowAlpha,
    shrinkWidth,
    background,
    isNumeric,
    isShrink,
    isSticky,
    measures,
    borders,
    colSpan,
    colors,
    isHead,
    layers,
    spaces,
    align
}: TableCellDynamicStyleType) => {
    const styles = {
        container: {
            paddingHorizontal: measures.cellPadding,
            alignItems: TABLE_CELL_ALIGNMENTS[align]
        } as Mutable<ViewStyle>,
        text: {} as Mutable<TextStyle>
    };

    if(isNumeric) {
        styles.text.fontVariant = [
            "tabular-nums"
        ];
    }

    if(!isShrink) {
        Object.assign(styles.container, {
            minWidth: measures.cellMinWidth * colSpan,
            flexGrow: colSpan
        });
    }

    if(isShrink && shrinkWidth) {
        styles.container.minWidth = shrinkWidth;
    }

    if(isSticky) {
        const stickyZIndexes = getTableStickyZIndexes({
            layers
        });

        Object.assign(styles.container, {
            backgroundColor: background,
            ...webStyle({
                boxShadow: isEdgeShadowVisible && stickyOffset === 0 ? `${directionSign * borders.indicator}px 0 ${spaces.spacingSm}px ${withAlpha({
                    color: colors.system.shadow,
                    alpha: shadowAlpha
                })}` : "none",
                zIndex: isHead ? stickyZIndexes.corner : stickyZIndexes.column,
                insetInlineStart: stickyOffset,
                position: "sticky"
            })
        });
    }

    return styles;
};
export default stylesheet;
